import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import alfredoIcon from "../assets/alfredo-icon.svg";
import * as AlfredoStyles from "../styles/SelectSubsidiary.styles";

const SelectSubsidiaryModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onSelectSubsidiary: (subsidiaryUuid: string) => void;
}> = ({ isOpen, onRequestClose, onSelectSubsidiary }) => {
  const [subdiaryApiAddress, setSubdiaryApiAddress] = useState("");
  const subdiaryApiAddressInputRef = useRef<HTMLInputElement>(null);


  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        subdiaryApiAddressInputRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  const handleSelectSubsidiary = () => {
    onSelectSubsidiary(subdiaryApiAddress);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSelectSubsidiary();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={AlfredoStyles.customStyles}
      contentLabel="Subsidiary Modal"
      ariaHideApp={false}
    >
      <AlfredoStyles.ModalWrapper>
        <AlfredoStyles.ModalContent>
          <AlfredoStyles.CloseButton onClick={onRequestClose}>&times;</AlfredoStyles.CloseButton>
          <img src={alfredoIcon} alt="Alfredo Ops" style={{ width: '35%', height: '35%' }} />
          <AlfredoStyles.Title>A L F R E D O OPERAÇÕES</AlfredoStyles.Title>
          <AlfredoStyles.SubTitle>Informe o endereço virtual da loja que deseja se conectar</AlfredoStyles.SubTitle>
          <AlfredoStyles.Input
            type="text"
            placeholder="Endereço da API"
            value={subdiaryApiAddress}
            onChange={(e) => setSubdiaryApiAddress(e.target.value)}
            onKeyPress={handleKeyPress}
            ref={subdiaryApiAddressInputRef}
          />
          <AlfredoStyles.Button onClick={handleSelectSubsidiary}>Conectar</AlfredoStyles.Button>
        </AlfredoStyles.ModalContent>
      </AlfredoStyles.ModalWrapper>
    </Modal>
  );
};

export default SelectSubsidiaryModal;
